var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.331 64C117.331 93.4552 93.4526 117.333 63.9974 117.333C34.5422 117.333 10.6641 93.4552 10.6641 64C10.6641 34.5448 34.5422 10.6667 63.9974 10.6667C93.4526 10.6667 117.331 34.5448 117.331 64ZM58.6641 37.3333C58.6641 34.3878 61.0519 32 63.9974 32C66.9429 32 69.3307 34.3878 69.3307 37.3333V64C69.3307 66.9455 66.9429 69.3333 63.9974 69.3333C61.0519 69.3333 58.6641 66.9455 58.6641 64V37.3333ZM58.6641 85.3333C58.6641 82.3878 61.0519 80 63.9974 80C66.9429 80 69.3307 82.3878 69.3307 85.3333C69.3307 88.2788 66.9429 90.6667 63.9974 90.6667C61.0519 90.6667 58.6641 88.2788 58.6641 85.3333Z",
    fill: "#FF0105"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/Attention.15cb59f669967d944c5557b82aeaab8a.svg";
export { ForwardRef as ReactComponent };